import { getStore } from '../../persistence/store';
import { zaehleRueckstand } from '../../server/rueckstand';
import { useAppStore } from '../../store/useAppStore';

/**
 * Die Brücke zwischen Zählen und Anzeigen.
 *
 * ⚠️ **Sie steht in `features/`, nicht im Store und nicht in `server/`.** Der Store darf
 * nichts aus `server/` holen, und `server/` weiß nichts von der Oberfläche (kein einziges
 * Modul dort importiert den Store). Die Oberfläche darf beides — also trägt sie es zusammen.
 *
 * ⚠️ **Wann gezählt wird, entscheiden die Aufrufer**, nicht ein Zeitgeber hier: nach jedem
 * Takt-Durchgang (`server/takt.ts`, `server/classic/takt.ts`), nach jeder Ablage einer
 * Aufnahme und einmal beim Start. Ein eigener Wecker daneben führe im Leerlauf zweimal in der
 * Minute über die Datenbank, ohne je etwas Neues zu finden.
 */
export async function meldeRueckstand(): Promise<void> {
  try {
    useAppStore.getState().setzeRueckstand(await zaehleRueckstand(getStore()));
  } catch {
    // Die Anzeige ist eine Auskunft, kein Betriebsmittel: sie bleibt beim letzten Stand.
  }
}

/** Ein Durchgang beginnt oder endet — die Pille zeigt es als eigenen Zustand. */
export function meldeUebertragungLaeuft(an: boolean): void {
  useAppStore.getState().setzeRueckstandSendet(an);
}

/** Die letzte Meldung der Übertragung, wie sie im Aufklapper steht. */
export function meldeUebertragungstext(text: string): void {
  useAppStore.getState().merkeRueckstandsmeldung(text);
}
